<nav class="top-nav">
  <div class="nav-content">
    <div class="nav-start">
      <div class="dashboard-logo">
        <img
          src="../../../assets/image/logo-dark.png"
          alt="logo"
          [routerLink]="['/home']"
        />
      </div>

      <div class="nav-buttons">
        <ng-container *ngIf="showSideNav">
          <ng-container *ngTemplateOutlet="showSideNav"></ng-container>
        </ng-container>
      </div>
    </div>

    <div class="nav-end">
      <button class="nav-action-btn lang-btn" (click)="switchLang()" type="button">
        <i class="fa fa-globe" aria-hidden="true"></i>
        <span>{{ currentLang === "en" ? "عربي" : "English" }}</span>
      </button>

      <button
        class="nav-action-btn bell-btn"
        (click)="openNotifications()"
        type="button"
      >
        <i class="fa-solid fa-bell"></i>
        <span class="badge-count" *ngIf="unreadCount > 0">
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>
      </button>

      <button
        class="nav-action-btn user-btn"
        type="button"
        (click)="op.toggle($event)"
      >
        <span class="hello">{{ "hello" | translate }}</span>
        <span class="user-name">{{ userName }}</span>
        <i class="fa fa-chevron-down chevron-icon"></i>
      </button>

      <p-overlayPanel #op styleClass="profile-overlay">
        <div class="overlay-content">
          <div class="overlay-header">
            <div class="avatar-badge">
              <img [src]="profileImageDisplay" [alt]="userName || 'User avatar'" class="avatar-img" (error)="onImageError($event)" />
            </div>
            <div class="overlay-user-name">
              <span>{{ userName }}</span>
            </div>
          </div>
          <div class="overlay-body">
            <a class="overlay-link" [routerLink]="['/dashboard/account-setting']" (click)="op.hide()">
              <div class="overlay-link-label">
                <i class="fa fa-cog" aria-hidden="true"></i>
                <span>{{ "SETTINGS" | translate }}</span>
              </div>
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </a>
            <hr />
            <div class="overlay-logout">
              <button (click)="logout()" type="button">
                {{ "LOGOUT" | translate }}
                <i class="fa fa-sign-out" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </p-overlayPanel>
    </div>
  </div>

</nav>

<app-notification-sidebar
#notifSidebar
[isRtl]="isRtl"
(unreadCountChange)="unreadCount = $event"
></app-notification-sidebar>